let thumbsArr = []

for (let i=1; i<9; i++) {
    thumbsArr = [...thumbsArr, require(`../assets/thumb/${i}.jpg`)]
}

export default thumbsArr


